module.exports = __webpack_public_path__ + "img/wp-existing-habit-card15.30fc35f3.jpg";